export default __webpack_public_path__ + "static/media/darjeeling3.137efc54.jpg";